import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from '@/hooks/useTranslation';
import styles from './index.module.scss';

export const Route = createFileRoute('/e/')({
  component: EmployeeHomePage,
});

function EmployeeHomePage() {
  const { t } = useTranslation();
  return (
    <div className={styles.page}>
      <h1 className={styles.title}>{t('K_WELCOME', 'Welcome')}</h1>
      <p className={styles.subtitle}>{t('K_YOUR_EMPLOYEE_PORTAL', 'Your employee portal')}</p>
    </div>
  );
}
